import React from "react";
import "./GroupOpponentWaiting.css";
import fallbackAvatar from "../../assets/images/c1.png";

const GroupBattleCard = ({ players = [], currentUserId = 0 }) => {
  const currentPlayer = players.find((player) => Number(player?.user_id || player?.id) === Number(currentUserId)) || players[0];
  const opponents = players.filter((player) => player !== currentPlayer);
  const playerName = (player) => player?.name || player?.user_name || "Player";
  const playerImage = (player) => player?.profile_pics || player?.image || fallbackAvatar;

  return (
    <div className="waitingRoomWrapper">
      <div className="waitingRoom">
        <div className="currentPlayerSection">
          <div className="playerImageWrapper">
            <img src={playerImage(currentPlayer)} alt="" className="playerImage" />
            <span className="youBadge">YOU</span>
          </div>
          <div className="playerName">{playerName(currentPlayer)}</div>
        </div>
        <div className="versusSection">
          <div className="versusLine" />
          <span className="versusText">Versus</span>
          <div className="versusLine" />
        </div>
        <div className="opponentsWrapper">
          {opponents.map((player, index) => (
            <div className="opponentItem" key={player?.user_id || player?.id || index}>
              <div className="waitingImageCircle">
                <img src={playerImage(player)} alt="" className="waitingOpponentImage" />
              </div>
              <div className="opponentWaitingText">{playerName(player)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GroupBattleCard;
